import { useRef, type ReactNode } from 'react';
import { useSlidingIndicator } from '@lib/hooks';

/**
 * One choice out of a few, as pressed buttons; the selected pill slides. `disabled` options stay visible but cannot be
 * picked. A label may carry more than text (a count).
 */
export function Segmented<T extends string>({ label, value, options, onChange, disabled = [] }: { label: string; value: T; options: [T, ReactNode][]; onChange: (v: T) => void; disabled?: T[] }) {
  const group = useRef<HTMLDivElement>(null);
  const thumb = useSlidingIndicator(group, "button[aria-pressed='true']", value, 'both');
  return (
    <div ref={group} className="segmented" role="group" aria-label={label}>
      <span ref={thumb} className="segmented-thumb" aria-hidden="true" />
      {options.map(([v, l]) => (
        <button key={v} type="button" aria-pressed={v === value} disabled={disabled.includes(v)} onClick={() => onChange(v)}>
          {l}
        </button>
      ))}
    </div>
  );
}
